<app-widget-card-wrapper [title]="title">
  <h5 class="card-title-medium">Target - A Full Circle</h5>
  <br />
  <div id="text-center"></div>
  <div class="card-stretch" echarts [options]="overviewChartOption"></div>
</app-widget-card-wrapper>
